import { createContext } from 'react';

export const UserAgentValuesContext = createContext({
  userAgent: {},
});

export default UserAgentValuesContext;
